import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import { faChevronDown, faSearch } from '@fortawesome/free-solid-svg-icons'
import Slider from '@mui/material/Slider';
import {  FormGroup, Label, Input } from 'reactstrap';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {advancedFilter, redirect} from '../../../slices/filterSlice'

class VolFilter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bgMain : false,
      bgSoute : false,
      nbrBgSoute : 0,
      adult: 1,
      enf : 0,
      baby : 0,
      escale : null,
      escaleNight : false,
      price : [0, 14000],
      companies : ["Air algérie", "Air France", "Emarates", "Qatar AirLines", "USA", "Turkish Airlines"],
      selectedCompanies : [],
      searchterm : '',
      selectAll : true,
    
    };
    this.IncrementItem = this.IncrementItem.bind(this);
    this.DecreaseItem = this.DecreaseItem.bind(this);
  }

  componentDidUpdate(){
    const url = new URLSearchParams(this.props.location.search);
    const params = {
     depart  : url.get("depart"),
     arrive : url.get("arrive"),
     origin : url.get("origin"),
     destination : url.get("destination")
  }
    this.props.dispatch(advancedFilter(this.state),params)
    this.props.dispatch(redirect(true))
    // this.state.selectAll ? this.setState({selectedCompanies: {...this.state.companies}}) : this.setState({selectedCompanies : []})
  }

  IncrementItem = (type) => {
    switch (type) {
      case "adult":
        this.setState({ adult: this.state.adult + 1 });
        break;
      case "enf":
        this.setState({ enf: this.state.enf + 1 });
        break;
      case "baby":
        this.setState({ baby: this.state.baby + 1 });
        break;
      default:
        break;
    }
  }
  DecreaseItem = (type) => {
    switch (type) {
      case "adult":
        if (this.state.adult > 0) {
        this.setState({ adult: this.state.adult - 1 });
        }
        break;
      case "enf":
        if (this.state.enf > 0) {
        this.setState({ enf: this.state.enf - 1 });
        }
        break;
      case "baby":
        if (this.state.baby > 0) {
        this.setState({ baby: this.state.baby - 1 });
        }
        break;
      default:
        break;
    }
    
  }
  ToggleClick = () => {
    this.setState({ show: !this.state.show });
  }
 
     handleChange =  (event, newValue) => {
        this.setState({
            price : newValue
        })
      };
    arrayRemove = (arr, value)=> { 
    
      return arr.filter(function(ele){ 
          return ele != value; 
      });
     }
    handleCheckedCompanies =(e)=>{
      const value = e.target.nextSibling.innerText;
      const checked = e.target.checked
      if (checked){
        this.setState({ selectedCompanies: [...this.state.selectedCompanies,value]})}
         else {
          var result = this.arrayRemove(this.state.selectedCompanies, value);
        
           this.setState({ selectedCompanies: result})}

      if ( e.target.name = "all" && checked ) {
        this.setState({selectedCompanies: [...this.state.selectedCompanies, this.state.companies]})
      }
      else if (e.target.name = "all" && !checked){
        this.setState({selectedCompanies : []})
      }
    }
    render() {
        return (
            <div className=' d-flex flex-column'>
         
                <a  data-toggle="collapse" className='show' aria-expanded="true" href="#collapseExample" role="button"  aria-controls="collapseExample">
                    <div className="filter__catego  show d-flex justify-content-between align-items-center">
                        <span className='catego__name'>Bagages</span>
                        <FontAwesomeIcon color='#37296a' icon={faChevronDown}/>
                    </div>
                </a>
 
                <div class="collapse show mt-3" id="collapseExample">
                    <FormGroup   check >
                      <Label className='mb-2 d-flex align-items-center' check>
                        <Input size="lg" className='filter__chk'  type="checkbox" onChange={(e)=>this.setState({bgMain : e.target.checked})}/>
                          <span className='filter__txt  '>Bagage(s) à main</span>
                      </Label>
                    
                      <Label className='d-flex mb-0 justify-content-between align-items-center' check>
                      <Input  className='filter__chk' type="checkbox" onChange={(e)=>this.setState({bgSoute : e.target.checked})}/>
                          <span className='filter__txt '>Bagage(s) en soute</span>
                    
                            {this.state.bgSoute && <Input size="sm" className="bgSelect" type="select" name="select" id="exampleSelect" onChange={(e)=>this.setState({nbrBgSoute : e.target.value})} >
                              <option>1</option>
                              <option>2</option>
                        </Input>}
                      </Label>
                    </FormGroup>
                  
                 
                </div>
                <div> <hr className='mt-3' /></div>
                <a  data-toggle="collapse" className='show' aria-expanded="true" href="#passg" role="button"  aria-controls="passg">
                    <div className="filter__catego  show d-flex justify-content-between align-items-center">
                        <span className='catego__name'>Passagers</span>
                        <FontAwesomeIcon color='#37296a' icon={faChevronDown}/>
                    </div>
                </a>
 
                <div class="collapse show mt-3" id="passg">
                    <div className="type__passg d-flex justify-content-between align-items-center mb-2">
                      <h6 className='mt-2'>Adultes (+11 ans)</h6>
                      <div className="type__incDec d-flex align-items-center">
                        <button className='filter__inc mr-2' onClick={()=>this.DecreaseItem("adult")}><span>-</span></button>
                        <span>{ this.state.adult }</span>
                        <button className='filter__inc ml-2' onClick={()=>this.IncrementItem("adult")}><span>+</span></button>
                      </div>
                    </div>
                    <div className="type__passg d-flex justify-content-between align-items-center mb-2">
                      <h6 className='mt-2'>Enfants (2- 11 ans)</h6>
                      <div className="type__incDec d-flex align-items-center">
                      <button className='filter__inc mr-2' onClick={()=>this.DecreaseItem("enf")}><span>-</span></button>
                        <span>{ this.state.enf }</span>
                        <button className='filter__inc ml-2' onClick={()=>this.IncrementItem("enf")}><span>+</span></button>
                      </div>
                    </div>
                    <div className="type__passg d-flex justify-content-between align-items-center ">
                      <h6 className='mt-2'>Bébé  (-2 ans)</h6>
                      <div className="type__incDec d-flex align-items-center">
                      <button className='filter__inc mr-2' onClick={()=>this.DecreaseItem("baby")}><span>-</span></button>
                        <span>{ this.state.baby }</span>
                        <button className='filter__inc ml-2' onClick={()=>this.IncrementItem("baby")}><span>+</span></button>
                      </div>
                    </div>
                    
             
                  
                 
                </div>
                <div> <hr className='mt-3' /></div>
                <a  data-toggle="collapse" className='show' aria-expanded="true" href="#escale" role="button"  aria-controls="escale">
                    <div className="filter__catego  show d-flex justify-content-between align-items-center">
                        <span className='catego__name'>Escales</span>
                        <FontAwesomeIcon color='#37296a' icon={faChevronDown}/>
                    </div>
                </a>
                <div class="collapse show mt-3" id="escale">
                    <FormGroup tag="fieldset" defaultValue={this.state.escale}>
                    
                      <FormGroup check  onChange={(e)=>this.setState({escale : e.target.value})}>
                        <Label className='mb-2 d-flex align-items-center'   check>
                          <Input className='filter__chk' type="radio" defaultChecked value={null} name="radio1"  />
                          <span className='filter__txt'>Tous</span>
                          
                        </Label>
                      
                        <Label className='mb-2 d-flex align-items-center'  check>
                          <Input className='filter__chk' type="radio" value={0} name="radio1" />{' '}
                          <span className='filter__txt'> Sans escale (direct)</span>
                         
                        </Label>
                    
                        <Label className='mb-2 d-flex align-items-center'  check>
                          <Input className='filter__chk' type="radio" value={1} name="radio1" />{' '}
                          <span className='filter__txt'>Jusqu'à 1 escale</span>
                          
                        </Label>
                   
                        <Label className='mb-0 d-flex align-items-center'  check>
                          <Input className='filter__chk' type="radio" value={2} name="radio1" />{' '}
                          <span className='filter__txt'>Jusqu'à 2 escales</span>
                          
                        </Label>
                      </FormGroup>
                     
                      
                    
                    </FormGroup>
                    <FormGroup >
                        <Label className='mb-2 d-flex align-items-center ml-0' check>
                          <Input  className='filter__chk ml-0'  type="checkbox" onChange={(e)=>this.setState({escaleNight : e.target.value})}/>
                            <span className='filter__txt ml-4'>Les escales d'une nuit</span>
                        </Label>
                    </FormGroup>
                  
                 
                </div>
                <div> <hr className='mt-2' /></div>
                <a  data-toggle="collapse" className='show' aria-expanded="true" href="#price" role="button"  aria-controls="price">
                    <div className="filter__catego  show d-flex justify-content-between align-items-center">
                        <span className='catego__name'>Prix</span>
                        <FontAwesomeIcon color='#37296a' icon={faChevronDown}/>
                    </div>
                </a>
                <div class="collapse show mt-3" id="price">
                <span><b>{this.state.price[0]}</b> EUR- <b>{this.state.price[1]}</b> EUR</span>    
                <Slider
                  getAriaLabel={() => 'Temperature range'}
                  value={this.state.price}
                  onChange={(event, newValue)=>this.handleChange(event,newValue)}
                  valueLabelDisplay="auto"
                  min ={0}
                  max={14000} 
                  step={100}
                />
                 
                </div>
                <div> <hr className='mt-2' /></div>
                <a  data-toggle="collapse" className='show' aria-expanded="true" href="#trans" role="button"  aria-controls="trans">
                    <div className="filter__catego  show d-flex justify-content-between align-items-center">
                        <span className='catego__name'>Transporteurs</span>
                        <FontAwesomeIcon color='#37296a' icon={faChevronDown}/>
                    </div>
                </a>
                <div class="collapse show mt-3" id="trans">
                    <div className="filter__search__input">
                      <input className='d-flex filter__searchInput ' type="text" name="campany" placeholder='Rechercher des compagnies...' onChange={(e) =>{this.setState({ searchterm : e.target.value})}} />
                      <FontAwesomeIcon className='filter__searchIcon' icon={faSearch} />
                    </div>
                    <Label className='mb-1 d-flex align-items-center mt-3' check>
                        <Input size="lg" className='filter__chk ml-0'  type="checkbox" checked={this.state.selectAll} onChange={(e)=>{this.handleCheckedCompanies(e);this.setState({selectAll : !this.state.selectAll})}}/>
                          <span className='filter__txt  ml-4'>Sélectionner tout</span>
                    </Label>

                    <h6 className='mt-3 font-weight-bold'>Résultats obtenus</h6>
                    <FormGroup   check onChange={(e)=> this.handleCheckedCompanies(e)}>
                      <SearchCompany selectAll={this.state.selectAll} companies ={ this.state.companies} searchterm={this.state.searchterm}/>
                   
                    <h6 className='mt-4 font-weight-bold '>Autres</h6>
                  
                      <Label className='mb-2 d-flex align-items-center' check>
                        <Input size="lg" className='filter__chk'  type="checkbox" checked = {this.state.selectAll}/>
                          <span className='filter__txt  '>Air Algérie</span>
                      </Label>
                      <Label className='mb-2 d-flex align-items-center' check>
                        <Input size="lg" className='filter__chk'  type="checkbox" checked = {this.state.selectAll}/>
                          <span className='filter__txt  '>Air France</span>
                      </Label>
                      <Label className='mb-2 d-flex align-items-center' check>
                        <Input size="lg" className='filter__chk'  type="checkbox" checked = {this.state.selectAll}/>
                          <span className='filter__txt  '>Qatar Airlines</span>
                      </Label>
                    </FormGroup>
                </div>
                <div> <hr className='mt-2' /></div>
            </div>
        )
    }

    
}

function SearchCompany(props) 


{
    
    const companyList= (company,index) => {
        return(
            <>
            <Label key={index} className='mb-2 d-flex align-items-center' check>
                        <Input size="lg" className='filter__chk'  type="checkbox"  checked = {props.selectAll} onChange={(e)=>e.target.checked=false} />
                          <span className='filter__txt  '>{company}</span>
            </Label>
        </>
        )
    }
    let companies = props.companies;
    let searchterm = props.searchterm
    return (
              
              companies.filter((val) => {
                  if ( searchterm== null || searchterm=="") {
                    return val ; 
                  }
                  else if (val.toLowerCase().includes(searchterm.toLowerCase()))
                  {
                    return val ; 
                  }
                

                }).map(companyList)
     
    ); 

}

function mapStateToProps(state) {
  return {
    startDate: state.date.startDate,
    endDate: state.date.endDate,
  }
}
export default withRouter(connect(mapStateToProps)(VolFilter));